<template>
  <div class="z-0 relative bg-white max-w-screen min-h-screen font-secondary">
    <ClientOnly>
      <NuxtLoadingIndicator :color="primaryColor" />
    </ClientOnly>
    <UApp>
      <NuxtPage class="z-10" />

      <ModalDebugger />
      <ConsentManagementBanner />
      <AppPrivacyPolicy />
      <AppSalesTerms />
      <DonateModalSuccess />
      <OtherEmailConfirmed />
    </UApp>
  </div>
</template>

<script setup lang="ts">
const primaryColor = usePrimaryColor()

useSetSEO()

useStoreUTM(true)

usePixels()

const route = useRoute()
const user = useUserStore()

watch(route, (value) => {
  user.logPage(value.path as string)
}, { deep: true, immediate: true })
</script>
